export const DEFAULT_DDI_COUNTRY_KEY = "+55-BR" // DDI key padrao do brasil
export const DEFAULT_DDI_COUNTRY_VALUE = "+55" // DDI value padrao do brasil